export default __webpack_public_path__ + "static/2-0e1d336e4065e4fecbe98d477a29a187.png";